/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsFilter } from './ContactDetailsFilter';
import {
    ContactDetailsFilterFromJSON,
    ContactDetailsFilterFromJSONTyped,
    ContactDetailsFilterToJSON,
} from './ContactDetailsFilter';

/**
 * 
 * @export
 * @interface GetPromptAggregateAnalyticsWithFiltersRequestContent
 */
export interface GetPromptAggregateAnalyticsWithFiltersRequestContent {
    /**
     * 
     * @type {string}
     * @memberof GetPromptAggregateAnalyticsWithFiltersRequestContent
     */
    questionId: string;
    /**
     * Return analytics on contacts created before this timestamp
     * @type {string}
     * @memberof GetPromptAggregateAnalyticsWithFiltersRequestContent
     */
    from?: string;
    /**
     * Return analytics on contacts after this timestamp
     * @type {string}
     * @memberof GetPromptAggregateAnalyticsWithFiltersRequestContent
     */
    to?: string;
    /**
     * 
     * @type {Array<ContactDetailsFilter>}
     * @memberof GetPromptAggregateAnalyticsWithFiltersRequestContent
     */
    filters?: Array<ContactDetailsFilter>;
}


/**
 * Check if a given object implements the GetPromptAggregateAnalyticsWithFiltersRequestContent interface.
 */
export function instanceOfGetPromptAggregateAnalyticsWithFiltersRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "questionId" in value;

    return isInstance;
}

export function GetPromptAggregateAnalyticsWithFiltersRequestContentFromJSON(json: any): GetPromptAggregateAnalyticsWithFiltersRequestContent {
    return GetPromptAggregateAnalyticsWithFiltersRequestContentFromJSONTyped(json, false);
}

export function GetPromptAggregateAnalyticsWithFiltersRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromptAggregateAnalyticsWithFiltersRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(ContactDetailsFilterFromJSON)),
    };
}

export function GetPromptAggregateAnalyticsWithFiltersRequestContentToJSON(value?: GetPromptAggregateAnalyticsWithFiltersRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'questionId': value.questionId,
        'from': value.from,
        'to': value.to,
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(ContactDetailsFilterToJSON)),
    };
}

